import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { Actividad } from '../models/actividad';
import { ActividadService } from '../services/actividad.service';
@Component({
  selector: 'app-actividades',
  templateUrl: './actividades.component.html',
  styleUrls: ['./actividades.component.css']
})
export class ActividadesComponent implements OnInit {


  models: Actividad[];

  constructor(private modelService: ActividadService, private formBuilder: FormBuilder) {
    this.models = [];
  }

  ngOnInit() {

    this.onSubmit();
  }

  onSubmit() {
    this.modelService.getAll().subscribe(val => {
      this.models = val;
    });
  }

}
